import {
  Box,
  Card,
  Container,
  Grid,
  LinearProgress,
  Typography
} from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import { DataTable } from "src/components/datagrid";
import CustomToolbar from "src/components/datagrid/widgets/CustomToolbar";
import { useAuth } from "src/hooks/useAuth";
import { useCarrierQueries } from "./hooks/useCarrierQueries";
import { useEffect, useRef } from "react";
import { CarrierColumns } from "./constants/CarriersColumns";
import { CarrierDetailsDrawers } from "./components/CarrierDetailsDrawer";
import { debounce, filter } from "lodash";

export function CarriersPage() {
  const { session } = useAuth();
  const { carrierId } = useParams();
  const {
    carriersPaginated,
    getCarriersPaginated,
    isCarriersPaginatedLoading,
    handleFetchWithNewParams,
  } = useCarrierQueries();

  useEffect(() => {
    getCarriersPaginated();
  }, [getCarriersPaginated]);

  const abortControllerRef = useRef(null);
  const debouncedSearch = debounce((model) => {
    if (model) {
      abortControllerRef.current?.abort();
      abortControllerRef.current = new AbortController();

      const quickFilters = model.quickFilterValues;
      let search = quickFilters.join(' ');
      let filters = model.items;
      if (filters.length) {
        filters.forEach((e) => {
          e['logic'] = model.logicOperator.toUpperCase()
        });
      }
      handleFetchWithNewParams({ filters: filters, search: search, signal: abortControllerRef.current?.signal });
    }
  }, 1000);

  return (
    <>
      <Helmet>
        <title> Carriers | {session.tenant.title} </title>
      </Helmet>
      <Container maxWidth="false" sx={{ width: 'fit-content', maxWidth: '100%' }}>
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Typography
            variant="h4"
            sx={{ mb: 1, mt: 3, textAlign: "center", display: "flex" }}
          >
            Carriers
          </Typography>
        </Box>
        <Box sx={{ my: 4, display: { md: "none" } }} />
        <Grid container item xs={12} width={'100%'} justifyContent={'center'}>
          <Card sx={{ minWidth: '50vw' }}>
            <section className="dataTable">
              <DataTable
                selectedItemId={carrierId}
                loading={isCarriersPaginatedLoading}
                loadData={carriersPaginated?.results ?? []}
                columns={CarrierColumns()}
                customDrawerComponent={CarrierDetailsDrawers}
                className="datagrid"
                pagination
                autoHeight
                density="compact"
                disableDensitySelector
                initState={{
                  columns: {
                    columnVisibilityModel: { id: false },
                  },
                }}
                slots={{
                  toolbar: () => <CustomToolbar columns={CarrierColumns()} rows={carriersPaginated?.results ?? []} title="Carriers" />,
                  loadingOverlay: LinearProgress,
                }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    printOptions: { disableToolbarButton: true },
                    quickFilterProps: { debounceMs: 500 },
                    loadData: carriersPaginated?.results ?? [],
                  },
                }}
                detailsDrawerTitle="Carriers"
                // detailColumns={CarrierDetailColumns}
                modelKey={"carriersPaginated"}
                modelGridSetup={{}}
                paginationMode="server"
                rowCount={carriersPaginated?.count ?? 0}
                page={(carriersPaginated?.currentPage ?? 0) - 1}
                filterMode="server"
                onFilterModelChange={debouncedSearch}
                onPaginationModelChange={(mod, det) => {
                  const pageForApi = mod.page + 1;
                  handleFetchWithNewParams({ page: pageForApi, limit: mod.pageSize });
                }}
              />
            </section>
          </Card>
        </Grid>
      </Container>
    </>
  );
}
